class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    if (this.slides.length === 0) return;

    this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
    this.index = 0;
    this.speed = (Number(this.dataset.speed) || 6) * 1000;
    this.autoplayEnabled =
      this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelector('[name="previous"]')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[name="next"]')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.addEventListener('touchstart', (event) => (this.touchX = event.changedTouches[0].clientX), {
      passive: true,
    });
    this.addEventListener(
      'touchend',
      (event) => {
        const delta = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(delta) > 40) this.go(delta < 0 ? this.index + 1 : this.index - 1);
      },
      { passive: true }
    );

    this.go(0);
  }

  disconnectedCallback() {
    this.stop();
  }

  go(target) {
    const total = this.slides.length;
    this.index = ((target % total) + total) % total;

    this.slides.forEach((slide, i) => {
      const isActive = i === this.index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.querySelectorAll('a, button').forEach((el) => {
        isActive ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1');
      });
    });

    this.dots.forEach((dot, i) => {
      const isActive = i === this.index;
      dot.classList.toggle('hero-slider__dot--active', isActive);
      isActive ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
    });

    this.start();
  }

  start() {
    this.stop();
    if (!this.autoplayEnabled || this.slides.length < 2) return;
    this.timer = setInterval(() => this.go(this.index + 1), this.speed);
  }

  stop() {
    clearInterval(this.timer);
  }
}

customElements.define('hero-slider', HeroSlider);
